(function() { window.GUID_b428c30f_4e83_4f28_91ac_995170089797 = { getGuid: function() { return "b428c30f-4e83-4f28-91ac-995170089797"; } }; })();
var CS;
(function (CS) {
    var Shared;
    (function (Shared) {
        class Section {
            constructor($context) {
                this.$context = $context;
                this.OnBindEvents();
            }
            Dispose() {
            }
            OnBindEvents() {
                var me = this;
            }
        }
        Shared.Section = Section;
    })(Shared = CS.Shared || (CS.Shared = {}));
})(CS || (CS = {}));

//# sourceMappingURL=sections.pre.js.map
